<script>
  import { createEventDispatcher } from 'svelte'
  const dispatch = createEventDispatcher()

  export let label
  export let label_visible = false
  export let icon
  export let position // 'left' or 'right'
  
  export let hovering = false
  
</script>

<button 
  class="{position}"
  class:hovering
  on:click={() => dispatch('click')}
  on:mouseenter={() => hovering = true}
  on:mouseleave={() => hovering = false}>
  <svg class="icon"><use xlink:href="#{icon}"/></svg>
  {#if hovering || label_visible}
    <span>
      {label}
    </span>
  {/if}
  </button>

<style>
  button {
    position: absolute;
    z-index: 1;
    top: 0;
    font-size: 1.3rem;
    letter-spacing: 0.02rem;
    line-height: 4rem;
    text-decoration: none;
    border: none;
    outline: none;
    background-color: transparent;
    color: var(--c-text);
    font-family: var(--PensumSans);
  }
  button.left {
    left: 0;
  }
  button.right {
    right: 0;
  }
  .left svg {
    float: left;
    margin-right: -0.5rem;
  }
  .right svg {
    float: right;
    margin-left: -0.5rem;
  }
  svg {
    float: left;
    stroke: var(--c-text-faded);
    --icon-color: var(--c-text-faded);
  }
  button.hovering {
    color: var(--c-text);
  }
  button.hovering svg {
    stroke: var(--c-accent);
    --icon-color: var(--c-accent);
  }

</style>